export default __webpack_public_path__ + "static/media/watch_now.b561799e.mp4";